import React from 'react';

const PartnerTablePrimaryCell = ({ title, subtitle, className = '' }) => (
  <div className={`partner-table-primary-cell partner-table-customer-cell ${className}`.trim()}>
    <strong>{title || '-'}</strong>
    {subtitle ? <span>{subtitle}</span> : null}
  </div>
);

export default PartnerTablePrimaryCell;
